import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { formatCurrency } from '../../utils/currency.utils';
import Card from './Card';
import { cardStyle } from './card.utils';
import BaseText from '../BaseText';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import { useTranslation } from 'react-i18next';
import i18n, { useComponentTKey, i18nNS } from '../../i18n';
import RowView from '../RowView';
import Icon from '../Icon';
import { GDS } from '../../constants/Enums';
import { scale } from '../../utils/scale.utils';

const AmenityItem = ({ label }) => {
  return (
    <RowView>
      <Icon color={Color.primary} name="check" />
      <BaseText style={CommonStyles.pl3}>{label}</BaseText>
    </RowView>
  );
};

const transformHoteItemDataToCard = (item = {}, currency, currencyCulture) => {
  const policyReasonCode = item.OutSidePolicyException?.ReasonCode?.toLowerCase();
  return {
    title: item.RoomDescriptionShort,
    subtitle: item.BeforeCancellationDate,
    value: formatCurrency(item.TotalPrice, currency, currencyCulture),
    textDownValue: i18n.t('resultCards:HotelCard.AvgPerNight'),
    policy: policyReasonCode,
    amenities: item.Amenities && item.Amenities.length > 0 ? item.Amenities.split(';') : null,
  };
};

const HotelRoomCard = ({ item, currency, currencyCulture, ...rest }) => {
  const { tKey } = useComponentTKey('HotelCard');
  const { t } = useTranslation(i18nNS.resultCards);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (Object.keys(item).length > 0) {
      setData(transformHoteItemDataToCard(item, currency, currencyCulture));
    }
  }, [item]);

  return data ? (
    <Card
      title={data.title}
      isHotelRoomCard={true}
      childrenTitle={
        <>
          <View style={[styles.inner, styles.container]}>
            <BaseText style={[CommonStyles.small, cardStyle.grayColor, CommonStyles.mt2]}>
              {item.IsNonRefundable ? t(tKey('Non-refundable')) : t(tKey('FreeCancelation'))}
            </BaseText>
            {item.Supplier.toLowerCase() === GDS.SABRE.toLowerCase() ? (
              <View style={[styles.option, { backgroundColor: Color.pointsEligibleColor }]}>
                <BaseText style={CommonStyles.small}>{t(tKey('PointsEligble'))}</BaseText>
              </View>
            ) : (
              <View style={[styles.option, { backgroundColor: Color.pointsUncertainColor }]}>
                <BaseText style={CommonStyles.small}>{t(tKey('PointsUncertain'))}</BaseText>
              </View>
            )}
          </View>
        </>
      }
      subtitle={data.subtitle}
      value={data.value}
      textDownValue={data.textDownValue}
      showPolicyName
      policy={data.policy}
      detail={
        <View style={cardStyle.composed}>
          <BaseText>{item.RoomDescriptionShort}</BaseText>
          {data.amenities ? (
            <View>
              <BaseText style={CommonStyles.py3}>Room Details:</BaseText>
              {data.amenities.map((amenity) => (
                <AmenityItem key={amenity} label={amenity} />
              ))}
            </View>
          ) : null}
        </View>
      }
      {...rest}
    ></Card>
  ) : (
    <></>
  );
};
const styles = StyleSheet.create({
  option: {
    ...CommonProperties.py1,
    ...CommonProperties.px3,
    ...CommonProperties.borderRadius3,
    ...CommonProperties.my1,
    ...CommonProperties.mx3,
    ...CommonProperties.shadow,
    alignSelf: 'flex-start',
  },
  container: {
    flex: 1,
    maxHeight: scale(25),
    flexDirection: 'row',
  },
  inner: {
    ...CommonProperties.my1,
    ...CommonProperties.mx3,
  },
});

export default HotelRoomCard;
